import {MessagesDictionary} from '../components/core/useGlobalMessage';

export const getErrorMessage = (errorCode: number, E: MessagesDictionary) => {
  switch (errorCode) {
    case -2:
      return E.generalAuthError;
    case -21:
      return E.userDoesntExistError;
    case -22:
      return E.userAlreadyExistsError;
    case -23:
      return E.incorrectPasswordError;
    case -25:
      return E.multipleUsersFound;
    case -26:
      return E.incorrectOTC;
    case -27:
      return E.userEmailAlreadyExistsError;
    case -28:
      return E.userPhoneAlreadyExistsError;
    default:
      return E.serverError;
  }
};